import { useNavigate } from "react-router";

import { Modal } from "@design-system/Modal/Modal";
import { Text } from "@design-system/Text/Text";

import { routes } from "@pages/routes";

export const GenerateReport = () => {
  const navigate = useNavigate();

  return (
    <Modal
      isOpen
      onClose={() =>
        navigate(routes.portal.dashboard.$path(), { viewTransition: true })
      }
    >
      <Text>Coming soon</Text>
    </Modal>
  );
};
